import React from "react";
import { Button } from "react-bootstrap";

const AppButton = ({
  text = "",
  size = "sm",
  leftIcon: LeftIcon,
  rightIcon: RightIcon,
  className = "",
  ...props
}) => {
  return (
    <Button
      size={size}
      className={`d-flex align-items-center justify-content-center gap-1 ${className}`}
      {...props}
    >
      {LeftIcon && <LeftIcon />}
      <h6 className="smallFont mb-0">{text}</h6>
      {RightIcon && <RightIcon />}
    </Button>
  );
};

export default AppButton;
